/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import SubmittedDeclarationIcon from 'assets/icons/SubmittedDeclarationIcon';
import { ICustomTheme } from 'interfaces';
import { StyledIconContainer } from './styles';
import { DeclarationDialog } from '../Dialog';

export const SubmittedDeclarationDialog = ({
  open,
  handleClose,
  goFirstStep,
  redirect,
  isNewDeclarationPossible,
  fetchDeclarations,
}: {
  open: boolean;
  handleClose: () => void;
  goFirstStep: () => void;
  redirect: () => void;
  isNewDeclarationPossible: boolean;
  fetchDeclarations: () => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  function goToDetailsPage(): void {
    handleClose();
    redirect();
  }

  function declareAgain(): void {
    fetchDeclarations();
    goFirstStep();
    handleClose();
  }

  return (
    <DeclarationDialog
      isOpen={open}
      isClosable={false}
      adornment={
        <StyledIconContainer>
          <SubmittedDeclarationIcon color={theme.colors.paletteFromBO.main} />
        </StyledIconContainer>
      }
      onCancel={goToDetailsPage}
      onConfirm={declareAgain}
      title={t('challenges.declaration.submittedDeclaration.title')}
      explanation={t('challenges.declaration.submittedDeclaration.explanation')}
      cancelLabel={t('challenges.declaration.submittedDeclaration.redirect')}
      confirmLabel={t(
        'challenges.declaration.submittedDeclaration.newDeclaration',
      )}
      cancelButtonProps={{ color: 'primary' }}
      confirmButtonProps={{
        color: 'secondary',
        css: { ...(!isNewDeclarationPossible && { display: 'none' }) },
      }}
    />
  );
};
